<div class="container">
  <pdq-checkbox
    labelSize="medium"
    (onChange)="toggleFeature($event)"
    [checked]="formGroup.value.feePerItem.enabled"
    label="Add cost per item"></pdq-checkbox>
  @if (formGroup.value.feePerItem.enabled) {
    <div class="card">
      <div *pdqHiddenInGlobaleMode>
        <div class="card__head">
          <pdq-heading element="h6" class="card__title">Item fee rules</pdq-heading>
          <span class="card__badge">New feature</span>
        </div>
        <p class="card__intro">Charge one flat fee per item, or scope fees to specific products.</p>

        <pdq-radio-group
          class="mode"
          variant="card"
          alignment="horizontal"
          [preserveTextCase]="true"
          name="feePerItemMode"
          [value]="isGroupMode ? 'group' : 'flat'"
          (onChange)="setMode($event === 'group')">
          <pdq-radio-button
            value="flat"
            text="Same fee for every item"
            subText="One rate applied to every item, regardless of product."
            [checked]="!isGroupMode"></pdq-radio-button>
          <pdq-radio-button
            value="group"
            text="Different fees by product"
            subText="Rates scoped by collection, type, tag, or vendor."
            [checked]="isGroupMode"></pdq-radio-button>
        </pdq-radio-group>
      </div>

      @if (isGroupMode) {
        <item-fee-setup-bar [formGroup]="formGroup" [shippingId]="shippingId"></item-fee-setup-bar>

        <item-fee-rules [formGroup]="formGroup"></item-fee-rules>

        <div class="globals">
          <div class="globals__eyebrow">If rules overlap or leave gaps</div>
          <div class="globals__row">
            <span>If an item is matched by more than one rule,</span>
            <pdq-dropdown
              mode="underline"
              [options]="overlapOptions"
              [defaultOption]="formGroup.value.feePerItem.overlapMode | dropdownOption: overlapOptions"
              (onChange)="setOverlapMode($event.value)"></pdq-dropdown>
          </div>
          <div class="globals__row">
            <span>For items that match no rule,</span>
            <pdq-dropdown
              mode="underline"
              [options]="unmatchedOptions"
              [defaultOption]="chargesUnmatched | dropdownOption: unmatchedOptions"
              (onChange)="setChargesUnmatched($event.value)"></pdq-dropdown>
            @if (chargesUnmatched) {
              <span>of</span>
              <pdq-input-arrows
                [dirty]="true"
                precision="2"
                min="0"
                widthSize="auto"
                [formControl]="$any(unmatchedFee.controls.amount)"
                aria-label="Fee per unmatched item"></pdq-input-arrows>
              <pdq-dropdown
                [options]="unmatchedFeeTypeOptions"
                [defaultOption]="unmatchedFee.value.type | dropdownOption: unmatchedFeeTypeOptions"
                (onChange)="setUnmatchedFeeType($event.value)"></pdq-dropdown>
            }
          </div>
        </div>

        <item-fee-preview [formGroup]="formGroup"></item-fee-preview>
      }

      @if (formLevelErrors.length) {
        <div class="fee-rules__errors">
          @for (error of formLevelErrors; track error) {
            <div>{{ error }}</div>
          }
        </div>
      }

      <div class="fee-rules" [hidden]="isGroupMode">
        <div class="fee-rules__list">
          @for (feeRule of feeRules.controls; track feeRule; let i = $index) {
            <div class="fee-rules__rule">
              Add
              <pdq-input-arrows
                [dirty]="true"
                precision="2"
                min="0"
                [formControl]="feeRule.controls.amount"
                widthSize="auto"
                width="50"></pdq-input-arrows>
              <pdq-dropdown
                (onChange)="setValue($event.value, i, 'type')"
                [defaultOption]="feeRule.value.type | feePerItemTypeOption: feeOptions"
                [options]="feeOptions"
                helpTextPosition="bottom"
                [formatter]="feeTypeTrigger"
                [disabled]="i > 0"></pdq-dropdown>
              additional shipping cost per
              <pdq-input-arrows
                [dirty]="true"
                [min]="stepAndThresholdMin"
                [precision]="stepAndTrhesholdPrecision"
                [formControl]="feeRule.controls.step"
                widthSize="auto"
                width="50"></pdq-input-arrows>
              <pdq-dropdown
                (onChange)="setValue($event.value, i, 'stepUnit')"
                [defaultOption]="feeRule.value.stepUnit | feePerItemstepUnitOption"
                [options]="feeUnitOptions"
                [disabled]="i > 0"></pdq-dropdown>
              up to
              <pdq-input-arrows
                [dirty]="true"
                [formControl]="feeRule.controls.threshold"
                [min]="stepAndThresholdMin"
                widthSize="auto"
                width="60"
                [precision]="stepAndTrhesholdPrecision"></pdq-input-arrows>
              {{ feeRule.value.stepUnit === FeeUnitType.ITEM ? 'items' : 'pounds' }}
              @if (i > 0) {
                <pdq-button
                  variant="empty"
                  size="small"
                  icon="trash"
                  iconColor="var(--error-default)"
                  (onClick)="deleteRule(i)"
                  [ariaLabel]="'Remove rule ' + (i + 1)"></pdq-button>
              }
            </div>
          }
        </div>
        <pdq-button (onClick)="addRule()">
          <span class="add-rule">
            <span class="add-rule__plus" aria-hidden="true"></span>
            Add
          </span>
        </pdq-button>
      </div>
    </div>
  }
</div>
